import { makeStyles } from '@material-ui/core';

export const useCheckboxStyles = makeStyles({
  label__disabled: {
    color: '#424242',
    fontWeight: 400,
    opacity: 0.5
  },
  label__default: {
    color: 'var(--neutrals-black)',
  },
  disabled: {
    opacity: 0.5
  },
  margin__checkbox: {
    marginLeft : '-10px'
  }
});

export default useCheckboxStyles;